import React, { useEffect } from 'react';
import HeaderV2 from './HeaderV2';
import HeroV2 from './HeroV2';
import AudienceFitV2 from './AudienceFitV2';
import MethodStepsV2 from './MethodStepsV2';
import DecisionScenariosV2 from './DecisionScenariosV2';
import TransparencyV2 from './TransparencyV2';
import FaqV2 from './FaqV2';
import ProgressiveDiagnosticV2 from './ProgressiveDiagnosticV2';
import LeadMagnetV2 from './LeadMagnetV2';
import ProofV2 from './ProofV2';
import CalculatorV2 from './CalculatorV2';
import FooterComplianceV2 from './FooterComplianceV2';
import { trackEvent, EVENTS } from '../../lib/analyticsV2';

const HomeV2 = () => {
  useEffect(() => {
    // Registra a visualização da landing page V2
    trackEvent(EVENTS.LP_VIEW, {
      page_version: 'v2',
      referrer_type: document.referrer ? 'external' : 'direct',
      device_class: window.innerWidth < 768 ? 'mobile' : 'desktop'
    });

    // Observer para disparar eventos de section_view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          trackEvent(EVENTS.SECTION_VIEW, {
            section_id: entry.target.id || 'unnamed_section',
            page_version: 'v2'
          });
          // Desobservar após o primeiro disparo para não flodar o analytics
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    // Observa todas as sections com ID
    document.querySelectorAll('section[id]').forEach(section => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground font-sans">
      <HeaderV2 />
      <main>
        <HeroV2 />
        <AudienceFitV2 />
        <MethodStepsV2 />
        <ProofV2 />
        <DecisionScenariosV2 />
        <CalculatorV2 />
        <TransparencyV2 />
        <FaqV2 />
        <LeadMagnetV2 />
        <ProgressiveDiagnosticV2 />
      </main>
      <FooterComplianceV2 />
    </div>
  );
};

export default HomeV2;
